'use client';

import React, { useState, useRef } from 'react';
import { FaCirclePlay } from 'react-icons/fa6';
import { GoDotFill } from 'react-icons/go';
import classNames from 'classnames';
import GradientBorder from 'ui/GradientBorder';
import styles from './styles.module.scss';

const Video = props => {
  const [playing, setPlaying] = useState(false);
  const ref = useRef();

  function hide() {
    const el = document.getElementById('exit-button');
    const isMobile = window.innerWidth < 768;

    document.body.style.overflow = 'initial';
    ref.current.pause();
    setPlaying(false);
    el.style.opacity = 0;
    if (isMobile) {
      document.getElementById('main-header').style.display = 'flex';
    }
  }

  function play() {
    const el = document.getElementById('exit-button');
    const isMobile = window.innerWidth < 768;

    ref.current.play();
    setPlaying(true);
    document.body.style.overflow = 'hidden';
    el.style.opacity = 1;

    if (isMobile) {
      document.getElementById('main-header').style.display = 'none';
      el.style.marginTop = '30px';
    }

    el.addEventListener('click', function () {
      hide();
    });
  }

  return (
    <>
      <div className={classNames(styles.videoOverlay, playing && styles.show)}>
        <div style={{ width: '100%', height: '100%', position: 'relative' }}>
          <video
            ref={ref}
            playsInline
            controls
            onEnded={() => {
              hide();
            }}
          >
            <source src={props.videoUrl} type="video/mp4" />
          </video>
        </div>
      </div>

      <GradientBorder>
        <div className={styles.videoContainer} onClick={play}>
          <div
            style={{
              position: 'absolute',
              right: 14,
              top: 14,
              zIndex: 100,
              padding: 4,
              paddingLeft: 8,
              paddingRight: 8,
              backgroundColor: '#00000099',
              fontSize: 12,
              borderRadius: 6,
              color: '#75e900',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: 3,
            }}
          >
            <GoDotFill />
            Online
          </div>

          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 200,
              position: 'absolute',
              top: 0,
              left: 0,
              opacity: 0.7,
              cursor: 'pointer',
            }}
          >
            <FaCirclePlay size={80} />
          </div>
          <video
            muted
            autoPlay
            loop
            playsInline
            style={{
              width: '100%',
              objectFit: 'cover',
              transform: 'translateY(-20px)',
            }}
          >
            <source src={props.thumbnailVideo} type="video/mp4" />
          </video>
        </div>
      </GradientBorder>
    </>
  );
};

export default Video;
